export class User {
	firstName: string;
	lastName: string;
	email: string;
	username: string;
	timeZone: string;
	userId: string;
	phoneNumber: string;
	constructor() {
		this.firstName = 'Testing';
		this.lastName = '';
		this.email = '';
		this.timeZone = '';
		this.username = '';
		this.userId = '';
		this.phoneNumber = '';
	}

	getUserProfile() {
		return {
			firstName: this.firstName,
			lastName: this.lastName,
			email: this.email,
			username: this.username,
			timeZone: this.timeZone,
			userId: this.userId,
			phoneNumber: this.phoneNumber,
		}
	}
}
